import React, { useState, useContext, Fragment } from 'react';
import BuildingSelector from './BuildingSelector';
import { ACSContext } from '../../contexts/ACSContext';
import { CMSContext } from '../../contexts/CMSContext';
import useLog from '../../hooks/useLog';
import FlatsView from './FlatsView';

const BuildingsView = () => {
  const [selectedFlat, setSelectedFlat] = useState(null); // State to track the selected flat
  const { startCall } = useContext(ACSContext);
  const {LogInfo} = useLog();
  const { buildings } = useContext(CMSContext);
  const [selectedBuildingIndex, setSelectedBuildingIndex] = useState(0);

  const handleDeviceClick = (device) => {
    LogInfo('Device clicked: ' + device.deviceid + ' calling ' + device.displayName);
    startCall(device);
  };

  const handleFlatClick = (flat) => {
    setSelectedFlat(flat === selectedFlat ? null : flat);
  };

  const handleBuildingSelected = (index) => {
    setSelectedBuildingIndex(index);
  };

  return (
    <Fragment>
      {buildings && buildings.length>0 && 
        <Fragment>
        <BuildingSelector buildings={buildings} selectedBuildingIndex={selectedBuildingIndex} onBuildingSelected={handleBuildingSelected} allowSelection={true}/>
        <FlatsView buildings={buildings} selectedFlat={selectedFlat} handleFlatClick={handleFlatClick} handleDeviceClick={handleDeviceClick} selectedBuildingIndex={selectedBuildingIndex}/>
      </Fragment>
      }
    </Fragment>
  );
};

export default BuildingsView;